import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { GridItemEditor } from "./GridItemEditor";
import { Box, IconButton } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import DeleteIcon from "@material-ui/icons/Delete";
import { PendingIconButton } from "@ploy-ui/core";
import { GridItemWrapper } from "./GridItemWrapper";
import { useIntl } from "react-intl";
import { defineMessage } from "@formatjs/intl";
export function SnackbarMessage({ children, variant }) {
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        enqueueSnackbar(children, {
            variant
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
}
const ContentGridItemImpl = (props) => {
    const { component, editable, onSave, onRemove, properties, id, ...rest } = props;
    const [open, setOpen] = useState(false);
    const intl = useIntl();
    let boxProps = { ...props.boxProps, ...properties.boxProps };
    if (editable && (onSave || onRemove)) {
        boxProps = {
            ...boxProps,
            headerAction: (_jsxs(Box, { display: "flex", children: [onRemove && (_jsx(PendingIconButton, { title: intl.formatMessage(defineMessage({
                            id: "dploy.grid.item.delete.title",
                            defaultMessage: "Delete"
                        })), size: "small", onClick: () => onRemove(id), children: _jsx(DeleteIcon, {}) })), onSave && (_jsx(IconButton, { title: intl.formatMessage(defineMessage({
                            id: "dploy.grid.item.settings.title",
                            defaultMessage: "Settings"
                        })), size: "small", onClick: () => setOpen(true), children: _jsx(SettingsIcon, {}) }))] }))
        };
    }
    return (_jsxs(_Fragment, { children: [onSave && (_jsx(GridItemEditor, { open: open, onClose: () => setOpen(false), component: component, initialValues: properties, onSubmit: async (values) => {
                    await onSave({ id, component, properties: values });
                    setOpen(false);
                } })), _jsx(GridItemWrapper, { ...rest, ...properties, component: component, properties: properties, id: id, boxProps: boxProps })] }));
};
ContentGridItemImpl.displayName = "DployContentGridItem";
export const ContentGridItem = memo(ContentGridItemImpl);
//# sourceMappingURL=ContentGridItem.js.map